<template>
  <div class="admin-clubs">
    <div class="panelheader border-2">

      <div class="title"> {{pageName}} </div>

      <div class="btn-wrapper">
        <el-button type="add" @click="onNewClub">New Club</el-button>
      </div>

    </div>

    <div class="clubs">
      <!-- <div v-if="newClub">
        <new-club @close="onClose"/>
      </div>
      <div v-else-if="editClub">
        <edit-club :clubData="clubData" @close="onClose"/>
      </div> -->
      <div v-if="newClub || editClub">
        <club-form
          :clubData="clubData"
          :isNewClub="newClub"
          @close="onClose"
        />
      </div>

      <div v-else>
        <club-table v-if='!reloading'
          @editClub="onEditClub"
          @deleteClub="onDeleteClub">
        </club-table>
      </div>
    </div>  

    <!-- DELETE CONFIRM -->
    <el-dialog
      :visible.sync="showDeleteConfirm"
      width="50%">
      <h3 slot="title" style="text-align: left;">
        Delete Club<span v-if="clubToDelete.name"> '{{clubToDelete.name}}'</span>?
      </h3>
      <div>Are you sure you wish to delete
        <span v-if="clubToDelete.name">
          <strong>'{{clubToDelete.name}}'</strong>
        </span>

        <span v-else>this club?</span>
      </div>

      <div>This is <strong>permanent</strong> and can't be undone.</div>

      <span slot="footer">
        <el-button @click="showDeleteConfirm = false">Cancel</el-button>
        <el-button type="danger" @click="doDelete">Delete</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import auth from '../../auth';
import requests from '../../requests';

import ClubTable from './ClubTable'
import ClubForm from './ClubForm'

export default {
  name: 'admin-clubs',
  data () {
    return {
      pageName: 'Adminstration Clubs',
      clubs: [],
      newClub: false,
      editClub: false,
      userIsSuperAdmin: false,
      clubData: {},
      reloading: false,
      showDeleteConfirm: false,
      clubToDelete: {},
    }
  },
  beforeMount(){
    var profile = JSON.parse(auth.getProfile());
    this.userIsSuperAdmin = (profile.role === 3);
  },
  updated() {
    this.reloading = false;
  },
  methods: {
    onNewClub() {
      this.editClub = false;
      this.newClub = true;
    },
    onEditClub(clubData) {
      this.clubData = clubData;

      this.newClub = false;
      this.editClub = true;
    },
    onDeleteClub(club) {
      this.showDeleteConfirm = true;
      this.clubToDelete = club;
    },
    doDelete() {
      var id = this.clubToDelete.id;
      var context = this;
      requests.deleteClub(this, id, result => {
        if(result.action !== 'success') {
          context.$message({
            type: 'error',
            message: 'Couldn\'t delete club: ' + result.msg
          })
        } else {
          context.$message({
            type: 'success',
            message: 'Successfully deleted club.',
            showClose: true
          })
        }
        this.reloading = true;
        this.showDeleteConfirm = false
      })
    },
    onClose() {
      this.newClub = false;
      this.editClub = false;
    },
  },
  components: {
    ClubTable,
    ClubForm
    // NewClub,
    // EditClub
  }
}
</script>

<style>

  .clubs {
    display: block;
    padding: 15pt;
    background-color: white;
  }

  .btn-wrapper {
    margin-top: 4pt;
    float: right;
    width: 20%;
    text-align: right;
    margin-right: 10pt;
  }

  .clubs .el-switch {
    float: left;
  }

  .clubs .el-select {
    float: left;
  }

  .el-table .email > .cell {
    word-break: break-all !important;
  }

</style>



// WEBPACK FOOTER //
// Clubs.vue?6c9e71e5